try {
  /* prevent default page load tags */
  window['tms'] = window['tms'] || {};
  window['tms'].queue = window['tms'].queue || [];
  window['tms'].preventdefault = true;
  /* set up queue functions */
  window['tms'].trackPage = window['tms'].trackPage || function () { tms.queue.push({ func: 'trackPage', args: arguments }); };
  window['tms'].init = window['tms'].init || function () { tms.queue.push({ func: 'init', args: arguments }); };

  /* declare analytics configuration settings */
  tms.data = {
    env_id: window.SacCoreService.environment, //dynamically populate depending on environment ('DEV', 'ACPT', 'PROD')
    loginstatus: true, //dynamically populate depending on if user is logged in
    prelogin_category: '/si2/moneymovement', //replace APPNAME with name of application
    postlogin_category: '/si2/moneymovement', //replace APPNAME with name of application
    dc_src: '2530996', //adjust only if instructed to by TMS
    sc_server: 'metric.schwabinstitutional.com', //adjust only if instructed to by TMS
    sc_secureserver: 'smetric.schwabinstitutional.com', //adjust only if instructed to by TMS
    report_suite_set: {
        //adjust only if instructed to by TMS
        DEV: 'cschwabadvisorservicesuat',
        ACPT: 'cschwabadvisorservicesuat',
        PROD: 'cschwabadvisorservicesprod'
    }
  };

  /* check to see if SPA tagging code has loaded */
  var tms_check_count = 0;
  var interval_tms = setInterval(tms_setup, 100);

  function tms_setup() {
  tms_check_count += 1;
        if (tms_check_count > 10) {
            clearInterval(interval_tms);
        }
        if (window['tms'] && typeof window['tms'].init === 'function') {
            /* initialize */
            window['tms'].init(window['tms'].data);
            clearInterval(interval_tms);
        }
      }
}
catch(err)
{
  console.log('tms setup error: ' + err);
}
/* End GUT tagging methods */
